const initialState = {
    userData: null,
};
const Reducer = (state = initialState, action)=>{
    
    switch (action.type) {
        case 'SET_USER_DETAILS':
            return {
                ...state,
                userData: action.payload,
            }   
        case 'CLEAR_USER_DETAILS':
            return {
                ...state,
                userData: null,
            }
        default:
            return state;
    }
};

export default Reducer;